import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';

import {
  type IRadioButton,
  RadioButton,
} from '../../../../../components/Toolkit/Inputs/RadioButton';
import { usePanelContentsSubscribe } from '../../../../../components/CarFinancePage/components/Panels/shared/CollapsiblePanel/CollapsiblePanel.hook';

type FinanceRadioButtonProps = Omit<IRadioButton, 'hasError'> &
  ControllerFieldState & { isOptional?: boolean };

export const FinanceRadioButton = forwardRef<
  HTMLInputElement,
  FinanceRadioButtonProps
>((props, ref) => {
  const { invalid, value, isOptional = false, ...rest } = props;
  usePanelContentsSubscribe({
    name: props.name,
    value,
    invalid,
    isOptional,
  });
  return <RadioButton {...rest} hasError={invalid} ref={ref} value={value} />;
});

FinanceRadioButton.displayName = 'FinanceRadioButton';
